// extracted by mini-css-extract-plugin
export default {"pagination":"PaginateAdmin_pagination__x7KIb","active":"PaginateAdmin_active__S2jET"};